/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ClinicianResponse } from './clinician-response';
import { OAuthToken } from './oauth-token';

/**
 * 
 * @export
 * @interface UserAuthorizationResponse
 */
export interface UserAuthorizationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserAuthorizationResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserAuthorizationResponse
     */
    'reason'?: UserAuthorizationResponseReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof UserAuthorizationResponse
     */
    'message'?: string | null;
    /**
     * Home region when reason is wrong_region. Clients map this through a compiled host list.
     * @type {string}
     * @memberof UserAuthorizationResponse
     */
    'region'?: UserAuthorizationResponseRegionEnum;
    /**
     * 
     * @type {OAuthToken}
     * @memberof UserAuthorizationResponse
     */
    'oauth_token'?: OAuthToken;
    /**
     * 
     * @type {ClinicianResponse}
     * @memberof UserAuthorizationResponse
     */
    'clinician'?: ClinicianResponse;
    /**
     * True when the user has an active DBInternalUser membership (RxFood staff). Login gate for the admin app.
     * @type {boolean}
     * @memberof UserAuthorizationResponse
     */
    'is_internal_user'?: boolean | null;
    /**
     * True when the internal user may impersonate (has_sudo).
     * @type {boolean}
     * @memberof UserAuthorizationResponse
     */
    'has_sudo'?: boolean | null;
    /**
     * Internal access tier (auditor < support < manager < admin); null when not internal staff.
     * @type {string}
     * @memberof UserAuthorizationResponse
     */
    'internal_role'?: UserAuthorizationResponseInternalRoleEnum;
}

export const UserAuthorizationResponseReasonEnum = {
    AuthFailed: 'auth_failed',
    InactiveUser: 'inactive_user',
    MfaTokenRequired: 'mfa_token_required',
    SecureTokenInvalid: 'secure_token_invalid',
    TokenInvalid: 'token_invalid',
    SudoFailed: 'sudo_failed',
    WrongRegion: 'wrong_region'
} as const;

export type UserAuthorizationResponseReasonEnum = typeof UserAuthorizationResponseReasonEnum[keyof typeof UserAuthorizationResponseReasonEnum];
export const UserAuthorizationResponseRegionEnum = {
    Ca: 'ca',
    Us: 'us'
} as const;

export type UserAuthorizationResponseRegionEnum = typeof UserAuthorizationResponseRegionEnum[keyof typeof UserAuthorizationResponseRegionEnum];
export const UserAuthorizationResponseInternalRoleEnum = {
    Auditor: 'auditor',
    Support: 'support',
    Manager: 'manager',
    Admin: 'admin'
} as const;

export type UserAuthorizationResponseInternalRoleEnum = typeof UserAuthorizationResponseInternalRoleEnum[keyof typeof UserAuthorizationResponseInternalRoleEnum];


